<template>
  <AppView>
    <!-- content @s -->
    <div class="nk-content nk-content-fluid">
      <div class="container-xl wide-xl">
        <div class="nk-content-inner">
          <div class="nk-content-body">
            <div class="nk-block-head nk-block-head-sm">
              <div class="nk-block-between">
                <div class="nk-block-head-content">
                  <h3 class="nk-block-title page-title">Usuarios</h3>
                  <div class="nk-block-des text-soft">
                    <p>Se encontraron un total de {{total}} usuarios.</p>
                  </div>
                </div><!-- .nk-block-head-content -->
                <div class="nk-block-head-content">
                  <div class="toggle-wrap nk-block-tools-toggle">
                    <a href="#" class="btn btn-icon btn-trigger toggle-expand mr-n1" data-target="pageMenu"><em class="icon ni ni-menu-alt-r"></em></a>
                    <div class="toggle-expand-content" data-content="pageMenu">
                      <ul class="nk-block-tools g-3">
                        <li><router-link to="/sistema/usuarios/nuevo" class="btn btn-white btn-outline-dark"><em class="icon ni ni-user-add"></em><span>Nuevo Usuario</span></router-link></li>
                      </ul>
                    </div>
                  </div><!-- .toggle-wrap -->
                </div><!-- .nk-block-head-content -->
              </div><!-- .nk-block-between -->
            </div><!-- .nk-block-head -->
            <TableGrid :rows="rows" :filters="filters" :total="total" @update="update">
              <template #filters>
                <div class="card-tools between-start overflow-auto">
                  <div v-for="filter in filters" class="mr-3" :key="filter.key">
                    <input v-if="filter.type === 'text'" type="text" autocomplete="new" class="form-control w-min-150px" :placeholder="filter.label" v-model.lazy="filter.value">
                  </div>
                </div>
              </template>
              <template #header>
                <div class="nk-tb-col"><span class="sub-text">ID</span></div>
                <div class="nk-tb-col"><span class="sub-text">Nombre</span></div>
                <div class="nk-tb-col tb-col-sm"><span class="sub-text">Usuario</span></div>
                <div class="nk-tb-col tb-col-sm"><span class="sub-text">Correo</span></div>
                <div class="nk-tb-col"><span class="sub-text">Rol</span></div>
                <div class="nk-tb-col tb-col-sm"><span class="sub-text">Fecha Alta</span></div>
                <div class="nk-tb-col text-right"><span class="sub-text">Acciones</span></div>
              </template>
              <template v-slot:row="slot">
                <div class="nk-tb-col">
                  <span>{{slot.row.id_user}}</span>
                </div>
                <div class="nk-tb-col">
                  <div class="user-card">
                    <div class="user-avatar xs bg-warning">
                      <span>{{$filters.initials(slot.row)}}</span>
                    </div>
                    <div class="user-name">
                      <router-link :to="'/sistema/usuarios/editar/'+slot.row.id_user">
                        <span>{{slot.row.name}} {{slot.row.lastname}}</span>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="nk-tb-col tb-col-sm">
                  <span>{{slot.row.username}}</span>
                </div>
                <div class="nk-tb-col tb-col-sm">
                  <span>{{slot.row.email}}</span>
                </div>
                <div class="nk-tb-col">
                  <span class="text-capitalize">{{slot.row.role}}</span>
                </div>
                <div class="nk-tb-col tb-col-sm">
                  <span>{{slot.row.registered}}</span>
                </div>
                <div class="nk-tb-col nk-tb-col-tools">
                  <ul class="nk-tb-actions gx-2">
                    <li>
                      <div class="drodown">
                        <a href="#" class="btn btn-sm btn-icon btn-trigger dropdown-toggle" data-toggle="dropdown"><em class="icon ni ni-more-h"></em></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <ul class="link-list-opt no-bdr">
                            <li><router-link :to="'/sistema/usuarios/editar/'+slot.row.id_user"><em class="text-primary icon ni ni-user-list"></em><span>Editar Usuario</span></router-link></li>
                            <li><a href="#" @click.prevent="remove(slot.row)"><em class="text-danger icon ni ni-user-remove"></em><span>Eliminar Usuario</span></a></li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </TableGrid>
          </div>
        </div>
      </div>
    </div>
    <!-- content @e -->
  </AppView>
</template>

<script>
import {reactive, ref, toRefs, defineComponent} from "vue";
import AppView from "@/components/sistema/AppView";
import TableGrid from "@/components/TableGrid";
import Swal from "sweetalert2";
import {useApi} from "@/use/useApi";
import {useRouter} from "vue-router";
export default defineComponent({
  name: "Usuarios",
  components: {TableGrid, AppView},
  setup() {
    const router = useRouter();

    const state = reactive({
      rows: [],
      total: 1
    });
    const filters = ref([
      {
        key: 'name',
        label: 'Nombre',
        value: '',
        type: 'text'
      },{
        key: 'lastname',
        label: 'Apellidos',
        value: '',
        type: 'text'
      },{
        key: 'email',
        label: 'Correo Electrónico',
        value: '',
        type: 'text'
      }
    ]);

    const { loading, make } = useApi();

    async function update(config){
      loading.message = 'Obteniendo información';
      let {data} = await make('administrators/get-all', config);
      if(data === null){
        Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
      } else {
        if(data.error){
          Swal.fire('Error', data.message, 'error');
        } else {
          state.rows = data.rows;
          state.total = data.total;
        }
      }
    }

    async function remove(user){
      Swal.fire({
        title: 'Eliminar usuario',
        text: '¿Estás seguro que deseas eliminar a ' + user.email + '?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar'
      }).then(async res => {
        if(res.isConfirmed){
          loading.message = 'Eliminando usuario';
          let {data} = await make('administrators/delete', {id_user: user.id_user});
          if(data === null){
            Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
          } else {
            if(data.error){
              Swal.fire('Error', data.message, 'error');
            } else {
              router.go();
            }
          }
        }
      });

    }

    return { ...toRefs(state), filters, remove, update }
  }
});
</script>

<style scoped>
</style>